import React, { useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import './CustomDropdown.css';

// Generic, styled dropdown not relying on native <select>
// Props:
// - options: [{ value, label }]
// - value: current value
// - onChange: (value) => void
// - placeholder: string
// - className: optional extra class for container
// - title: heading of the mobile bottom sheet
const CustomDropdown = ({ options = [], value = null, onChange, placeholder = 'Не выбрано', className = '', title = 'Выберите список' }) => {
  const [open, setOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(() => window.innerWidth <= 720);
  const ref = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        ref.current
        && !ref.current.contains(event.target)
        && !event.target.closest('.custom-dropdown-portal')
      ) {
        setOpen(false);
      }
    };
    const handleResize = () => setIsMobile(window.innerWidth <= 720);
    document.addEventListener('mousedown', handleClickOutside);
    window.addEventListener('resize', handleResize);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const selected = options.find((o) => `${o.value}` === `${value}`) || null;

  const handleSelect = (val) => {
    if (onChange) onChange(val);
    setOpen(false);
  };

  const optionsList = (
    <div className="custom-dropdown__options">
      {options.map((opt) => (
        <div
          key={opt.value}
          role="option"
          aria-selected={`${opt.value}` === `${value}`}
          className="custom-dropdown__option"
          onClick={() => handleSelect(opt.value)}
        >
          {opt.label}
        </div>
      ))}
    </div>
  );

  return (
    <div className={`custom-dropdown ${className}`} ref={ref}>
      <div
        className="custom-dropdown__control"
        role="button"
        aria-haspopup="listbox"
        aria-expanded={open}
        onClick={() => setOpen((v) => !v)}
      >
        <span className={!selected ? 'custom-dropdown__placeholder' : ''}>
          {selected ? selected.label : placeholder}
        </span>
        <i className={`custom-dropdown__chevron ${open ? 'up' : 'down'}`} />
      </div>
      {open && !isMobile && (
        <div className="custom-dropdown__menu" role="listbox">
          {optionsList}
        </div>
      )}
      {open && isMobile && createPortal(
        <div className="custom-dropdown-portal">
          <button
            className="custom-dropdown-portal__backdrop"
            type="button"
            aria-label="Закрыть список"
            onClick={() => setOpen(false)}
          />
          <div className="custom-dropdown__menu custom-dropdown__menu--portal" role="listbox">
            <div className="custom-dropdown__sheet-heading">
              <div>
                <strong>{title}</strong>
                <span>{selected ? selected.label : placeholder}</span>
              </div>
              <button type="button" className="ui-close ui-close--sm" onClick={() => setOpen(false)} aria-label="Закрыть">×</button>
            </div>
            {optionsList}
          </div>
        </div>,
        document.body
      )}
    </div>
  );
};

export default CustomDropdown;

